module.exports = __webpack_public_path__ + "static/media/599.7554(17).5a9e255b.pdf";